import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import {
  Box,
  Card,
  CardMedia,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import deleteImage from "../../../../assets/images/png/delete.png";
import editImage from "../../../../assets/images/png/edit.png";
import payImg from "../../../../assets/images/png/pay.png";
import print from "../../../../assets/images/png/print.png";
import saveImag from "../../../../assets/images/png/save.png";
import CustomButton from "../../../../components/CustomButton";
import { default as Checkbox } from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import {
  default as CustomSelect,
  default as Select,
} from "../../../../components/Select/Select";
import {
  addBillingItemsByPaymentId,
  deletePaymentItemById,
  getBillDetailsByPaymentId,
  getClinicStocks,
  getServices,
  updateBillingByPaymentId,
  updateBillingItemsByPaymentId,
  updatePayment,
} from "../../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../../util/AppColors";
import { radioDiscountTypes } from "../../../../util/arrayList";
import { discountTypes, PaymentTypeList } from "../../../../util/dropList";
import {
  getBorderColor,
  getPharmacyRecordBasedType,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
} from "../../../../util/function";
import "./Billing.css";

const trtTblHdrs = [
  "serviceitemname",
  "qty",
  "unitPrice",
  "discount",
  "adminCharge",
  "total",
  "pay",
];

const phrTblHdrs = [
  "serviceitemname",
  "qty",
  "unitPrice",
  "discount",
  "tax",
  "total",
  "pay",
];

const tableNameExpan = {
  serviceitemname: "Service/Item Name",
  qty: "Qty",
  unitPrice: "Unit Price",
  tax: "Tax",
  adminCharge: "Admin Charge",
  total: "Total",
  days: "Days",
  discount: "Discount",
};

const initialValues = {
  quantity: 1,
  price: 0,
  unitType: "Unit",
  discountType: discountTypes?.[0],
};
const initialPayValues = { amount: "", paymentMode: PaymentTypeList?.[0] };
const initialDiscount = { type: "price", amt: "" };
const initialPayments = {
  subTotal: 0,
  tax: "-",
  discount: 0,
  amtPaid: 0,
  balDue: 0,
};

const Billing = ({ bill }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const contentToPrint = useRef(null);
  const [activeTab, setActiveTab] = useState("Treatment");
  const [selectedItem, setSelectedItem] = useState(null);
  const [discountValues, setDiscountValues] = useState(initialDiscount);
  const [searchVisible, setSearchVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [discountModVisible, setDiscountModVisible] = useState(false);
  const [delModVisible, setDelModVisible] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState(initialPayments);
  const [searchValue, setSearchValue] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [itemValues, setItemValues] = useState(initialValues);
  const [prntPrevVsble, setPrntPrevVsble] = useState(false);
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [payValues, setPayValues] = useState(initialPayValues);
  const appDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const billDetails = useSelector((state) => state?.clinic?.billDetails);
  const clinicDet = useSelector((state) => state?.clinic?.details);
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);
  const petDet = appDet?.pet;
  const apnt = appDet?.appointment;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    if (bill?.paymentId ?? petDet?.paymentId) {
      dispatch(getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId));
    }
    dispatch(getClinicStocks());
    getProductAndServiceListForDropdown();
  }, []);

  useEffect(() => {
    getPaymentDetails();
  }, [billDetails]);

  useEffect(() => {
    if (!searchVisible) return;
    if (searchValue?.length > 0) {
      const reqPrdList = stocks?.data
        ?.filter((dta) => {
          return dta?.stockBatch?.find((btch) => btch?.quantity > 0);
        })
        ?.map((li) => ({ ...li, name: li?.tradeName, type: "Product" }));
      const reqList =
        activeTab === "Treatment"
          ? [...(serviceList ?? []), ...(reqPrdList ?? [])] ?? []
          : reqPrdList ?? [];

      const filList = reqList?.filter(
        (sp) =>
          sp?.name?.toLowerCase().includes(searchValue?.toLowerCase()) ||
          sp?.tradeName?.toLowerCase().includes(searchValue?.toLowerCase())
      );
      setFilteredList(filList);
    }
  }, [searchValue, searchVisible, activeTab]);

  const getPaymentDetails = () => {
    let subTotal = 0,
      tax = 0,
      discount = 0,
      balDue = 0;
    if (billDetails?.paymentDetails?.length > 0) {
      billDetails?.paymentDetails?.map((pd) => {
        tax = tax + Number(pd?.tax) ?? 0;
        subTotal = subTotal + pd?.total;
      });
    }
    if (discountValues?.type && Number(discountValues?.amt) > 0) {
      if (discountValues?.type === "price") {
        discount = Number(discountValues?.amt);
      }
      if (discountValues?.type === "percentage") {
        discount = (subTotal / 100) * Number(discountValues?.amt);
      }
    }
    balDue = subTotal - (discount + billDetails?.amtPaid);
    setPaymentDetails({ ...paymentDetails, subTotal, tax, discount, balDue });
  };

  const getProductAndServiceListForDropdown = () => {
    let reqServices = [];
    dispatch(getServices()).then((res) => {
      if (res?.payload?.data?.length > 0) {
        reqServices = res?.payload?.data?.map((ser) => {
          return {
            ...ser,
            name: ser?.serviceName,
            value: ser?.serviceId,
            type: "Service",
          };
        });
      }
      setServiceList(reqServices);
    });
  };

  const handleDelete = (bill) => {
    setSelectedItem(bill);
    setDelModVisible(true);
  };

  const handleDelConfirm = () => {
    dispatch(deletePaymentItemById(selectedItem?.paymentDetailId)).then(
      (res) => {
        if (res?.payload) {
          handleUpdatePaymentValues();
          setSelectedItem(null);
          setDelModVisible(false);
        }
      }
    );
  };

  const handleEdit = (bill) => {
    const batchList = getBatchList(bill?.stockId);
    const reqBatch = batchList?.find((bat) => bat?.batchId === bill?.batchId);
    const reqObj = {
      ...itemValues,
      name: bill?.name,
      quantity: bill?.quantity,
      price: bill?.price,
      tax: bill?.tax,
      serviceId: bill?.serviceId ?? null,
      productId: bill?.productId ?? null,
      unitType: bill?.subUnit ?? "Unit",
      adminCharge: bill?.adminCharge ?? "N",
      adminChargeAmount: bill?.adminChargeAmount ?? 0,
      paymentDetailId: bill?.paymentDetailId,
      discount: bill?.discount,
      discountType:
        bill?.discountType === "pe" ? discountTypes?.[1] : discountTypes?.[0],
      stockId: bill?.stockId,
      batchId: bill?.batchId,
      batchNumber: reqBatch ?? null,
    };
    if (bill?.discountType === "pe") {
      const reqPercent = (Number(bill?.discount) / Number(bill?.price)) * 100;
      reqObj.discount = reqPercent;
    }
    setItemValues(reqObj);
    setSelectedItem(bill);
    setEditVisible(true);
  };

  const onDiscountModClose = () => {
    setDiscountModVisible(!discountModVisible);
  };

  const onChangeDiscount = (name, value) => {
    setDiscountValues({ ...discountValues, [name]: value });
  };

  const onChangeItemValue = (name, value, addObj) => {
    const reqObj = { ...itemValues, [name]: value };
    if (name === "batchNumber" && addObj) {
      reqObj.batchId = addObj?.batchId;
    }
    setItemValues(reqObj);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setSelectedItem(null);
  };

  const handleAddDiscount = () => {
    getPaymentDetails();
    onDiscountModClose();
  };

  const handlePrint = useReactToPrint({
    documentTitle: `${clinicDet?.name ?? ""}-${
      billDetails?.invoiceNumbers ?? ""
    }`,
    removeAfterPrint: true,
  });

  const handleUpdatePaymentValues = async () => {
    dispatch(
      getBillDetailsByPaymentId(
        location?.state?.bill?.paymentId ?? bill?.paymentId ?? petDet?.paymentId
      )
    ).then(async (res) => {
      const pay = res?.payload;

      let subTotal = 0,
        tax = 0,
        discount = 0;

      if (pay?.paymentDetails?.length > 0) {
        pay?.paymentDetails?.map((pd) => {
          tax = tax + Number(pd?.tax) ?? 0;
          subTotal = subTotal + pd?.total;
        });
      }
      if (discountValues?.type && Number(discountValues?.amt) > 0) {
        if (discountValues?.type === "price") {
          discount = Number(discountValues?.amt);
        }
        if (discountValues?.type === "percentage") {
          discount = (subTotal / 100) * Number(discountValues?.amt);
        }
      }
      const reqData = {
        paymentId:
          location?.state?.bill?.paymentId ??
          pay?.paymentId ??
          petDet?.paymentId,
        data: {
          totalAmt: Number(subTotal ?? 0),
          amtPaid: Number(pay?.amtPaid ?? 0),
          discount: Number(discount ?? 0),
          tax: Number(tax ?? 0),
        },
      };

      dispatch(updateBillingByPaymentId(reqData))?.then((apiRes) => {
        if (apiRes?.payload) {
          dispatch(
            getBillDetailsByPaymentId(
              location?.state?.bill?.paymentId ??
                bill?.paymentId ??
                petDet?.paymentId
            )
          );
        }
      });
    });
  };

  const handleAddItem = async (item) => {
    const reqObj = {
      billType: activeTab === "Treatment" ? "administered" : "prescribed",
      adminCharge: "N",
      adminChargeAmount: 0,
      name: item?.name ?? searchValue,
      quantity: 1,
      type: item ? (item?.serviceId ? "service" : "product") : "service",
      discount: 0,
      percentage: false,
      subUnit: "Unit",
    };
    if (item?.productId) reqObj.productId = item?.productId;
    if (item?.serviceId) {
      reqObj.serviceId = item?.serviceId;
      reqObj.price = Number(item?.servicePrice ?? 0);
      reqObj.tax = 0;
      reqObj.total = Number(item?.servicePrice ?? 0);
    }
    if (item?.stockId) {
      const reqBat = item?.stockBatch?.[0];
      reqObj.stockId = item?.stockId;
      if (reqBat) {
        reqObj.batchId = reqBat?.batchId;
        if (activeTab === "Pharmacy") {
          const taxPerent =
            Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
          const reqPercent = 100 + Number(taxPerent);
          const unitPrice =
            Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
          const prdTaxValue = (taxPerent / 100) * Number(unitPrice);
          reqObj.tax = Number(prdTaxValue);
          reqObj.total = Number(unitPrice) + Number(prdTaxValue);
          reqObj.price = unitPrice;
        }
        if (activeTab === "Treatment") {
          const unitPrice = Number(reqBat?.unitSellingPrice);
          reqObj.total =
            Number(unitPrice) + Number(reqBat?.administeringCharges ?? 0);
          reqObj.adminCharge = "Y";
          reqObj.price = unitPrice;
          reqObj.tax = 0;
          reqObj.adminChargeAmount = Number(reqBat?.administeringCharges ?? 0);
        }
      }
    }
    if (!item) {
      reqObj.price = 0;
      reqObj.tax = 0;
      reqObj.total = 0;
    }
    const reqData = {
      paymentId:
        location?.state?.bill?.paymentId ??
        bill?.paymentId ??
        petDet?.paymentId,
      data: reqObj,
    };
    dispatch(addBillingItemsByPaymentId(reqData))?.then((res) => {
      if (res?.payload) {
        handleUpdatePaymentValues();
        setSearchValue("");
        setSearchVisible(false);
      }
    });
  };

  const handleUpdateItem = async (item) => {
    const reqStck = stocks?.data?.find(
      (stc) => stc?.stockId === itemValues?.stockId ?? item?.stockId
    );
    const reqBat = reqStck?.stockBatch?.find(
      (btch) => btch?.batchId === itemValues?.batchId ?? item?.batchId
    );

    let discount =
      itemValues?.discountType?.value !== "Percentage"
        ? Number(itemValues?.discount ?? 0)
        : Number(
            Number(Number(itemValues?.price ?? 0) / 100) *
              Number(itemValues?.discount ?? 0)
          ) ?? 0;
    const reqObj = {
      paymentDetaisId: selectedItem?.paymentDetailId ?? item?.paymentDetailId,
      tax: 0,
      adminCharge: "N",
      adminChargeAmount: 0,
      quantity: Number(itemValues?.quantity),
      type: item?.type,
      percentage: itemValues?.discountType?.value === "Percentage",
      stockId: itemValues?.stockId,
      batchId: itemValues?.batchId,
      name: itemValues?.name,
      billType: item?.billType,
      serviceId: item?.serviceId,
    };
    if (reqBat) {
      if (activeTab === "Treatment") {
        const unitPrice = Number(reqBat?.unitSellingPrice);
        const priceAfterDiscount = Number(unitPrice) - Number(discount);
        reqObj.price = unitPrice;
        reqObj.discount = discount;
        reqObj.adminCharge = "Y";
        reqObj.adminChargeAmount = Number(reqBat?.administeringCharges ?? 0);
        reqObj.total =
          Number(
            Number(priceAfterDiscount) +
              Number(reqBat?.administeringCharges ?? 0)
          ) * Number(itemValues?.quantity);
      }
      if (activeTab === "Pharmacy") {
        const taxPerent = Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
        const reqPercent = 100 + Number(taxPerent);
        const unitPrice = Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
        const priceAfterDiscount = Number(unitPrice) - Number(discount);
        const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
        reqObj.price = unitPrice;
        reqObj.discount = discount;
        reqObj.tax = Number(taxValue ?? 0) * Number(itemValues?.quantity);
        reqObj.total =
          Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
          Number(itemValues?.quantity);
      }
    }
    if (!item?.serviceId && !item?.stockId) {
      reqObj.price = Number(itemValues?.price ?? 0);
      reqObj.tax = 0;
      reqObj.discount = discount;
      reqObj.total =
        (Number(itemValues?.price ?? 0) - Number(discount ?? 0)) *
        Number(itemValues?.quantity);
    }
    if (item?.serviceId) {
      reqObj.price = Number(itemValues?.price ?? 0);
      reqObj.discount = discount;
      reqObj.total =
        (Number(itemValues?.price ?? 0) - Number(discount ?? 0)) *
        Number(itemValues?.quantity);
    }

    const reqData = {
      paymentId:
        location?.state?.bill?.paymentId ??
        bill?.paymentId ??
        petDet?.paymentId,
      data: reqObj,
    };
    const apiRes = await dispatch(updateBillingItemsByPaymentId(reqData));
    if (apiRes?.payload) {
      handleUpdatePaymentValues();
      setSelectedItem(null);
      setEditVisible(false);
    }
  };

  const handleClosePrintModal = () => {
    setPrntPrevVsble(false);
  };

  const finalPayment = () => {
    const data = {
      paymentId: billDetails?.paymentId,
      paymentMode: payValues?.paymentMode?.value,
      paymentAmount: payValues?.amount,
    };

    dispatch(updatePayment(data)).then((res) => {
      if (res?.meta?.requestStatus === "fulfilled") {
        if (bill?.paymentId ?? petDet?.paymentId) {
          dispatch(
            getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId)
          );
        }
        setPayModalVisible(false);
        setPayValues(initialPayValues);
      }
    });
  };

  const payModClose = () => {
    setPayValues(initialPayValues);
    setPayModalVisible(!payModalVisible);
  };

  const handleChangeValues = (name, value) => {
    setPayValues({ ...payValues, [name]: value });
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    const filteredBatches = reqStock?.stockBatch
      // ?.filter((btch) => btch?.quantity > 0)
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
      }));
    return filteredBatches;
  };

  return (
    <div className="back-white w100Per">
      <Container maxWidth="xl">
        <Box className="pb20">
          <div className="flex-row mb20">
            <div className="w15Per">
              <CustomButton
                text="Treatment"
                onClick={() => setActiveTab("Treatment")}
                tabOutlined
                yellowBtn={activeTab === "Treatment"}
              />
            </div>
            <div className="w5Per">
              <div className="flex-center">
                <div className="ver-bar-h30" />
              </div>
            </div>
            <div className="w15Per">
              <CustomButton
                text="Pharmacy"
                onClick={() => setActiveTab("Pharmacy")}
                tabOutlined
                yellowBtn={activeTab === "Pharmacy"}
              />
            </div>
            <div className="flex1-end">
              <div className="flex-column">
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 gray4">
                    Amount Paid
                  </Typography>
                  <Typography className="green-color fs16 font-bold ml10">
                    Rs{" "}
                    {Number(billDetails?.amtPaid) > 0
                      ? Number(billDetails?.amtPaid)?.toFixed(2)
                      : Number(billDetails?.amtPaid)}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 gray4">
                    Balance Due
                  </Typography>
                  <Typography className="yellow-color fs16 font-bold ml10">
                    Rs{" "}
                    {Number(
                      Number(
                        getTaxAndSubTotalAndTotal(
                          getTreatmentRecordBasedType(
                            billDetails?.paymentDetails
                          )
                        )?.subTotal +
                          getTaxAndSubTotalAndTotal(
                            getPharmacyRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.subTotal
                      ) -
                        (Number(billDetails?.amtPaid ?? 0) -
                          Number(billDetails?.discount ?? 0))
                    )?.toFixed(2)}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <TableContainer sx={{ maxHeight: 250 }}>
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {(activeTab === "Treatment" ? trtTblHdrs : phrTblHdrs)?.map(
                    (hl, i) => (
                      <TableCell
                        key={i}
                        style={{
                          backgroundColor: AppColors.tableGrey,
                          color: AppColors.white,
                          textAlign: "left",
                        }}
                        sortDirection={false}
                        className={`table-header-text ${
                          hl === "name" ? "w30Per" : "w15Per"
                        }`}
                      >
                        {tableNameExpan?.[hl]}
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {(activeTab === "Treatment"
                  ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
                  : getPharmacyRecordBasedType(billDetails?.paymentDetails)
                )?.length > 0 &&
                  (activeTab === "Treatment"
                    ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
                    : getPharmacyRecordBasedType(billDetails?.paymentDetails)
                  )
                    ?.filter((pd) => pd?.type === "consultation")
                    ?.map((con) => {
                      const reqObj = {
                        serviceitemname: `Consultation(${billDetails?.appointmentType})`,
                        qty:
                          selectedItem?.paymentDetailId ===
                            con?.paymentDetailId && editVisible ? (
                            <CustomTextField
                              value={itemValues?.quantity}
                              handleChange={(e) =>
                                onChangeItemValue("quantity", e?.target?.value)
                              }
                              fullWidth
                              type="number"
                            />
                          ) : (
                            con?.quantity
                          ),
                        unitPrice:
                          selectedItem?.paymentDetailId ===
                            con?.paymentDetailId && editVisible ? (
                            <CustomTextField
                              value={itemValues?.price}
                              handleChange={(e) =>
                                onChangeItemValue("price", e?.target?.value)
                              }
                              fullWidth
                              type="number"
                            />
                          ) : (
                            `Rs ${
                              Number(con?.price) > 0
                                ? Number(con?.price).toFixed(2)
                                : Number(con?.price)
                            }`
                          ),
                        tax:
                          Number(con?.tax) > 0
                            ? Number(con?.tax).toFixed(2)
                            : "-",
                        total: `Rs ${Number(con?.total).toFixed(2)}`,
                        days: con?.days ?? "-",
                      };
                      if (apnt?.appointmentStatus !== "completed") {
                        reqObj.pay =
                          selectedItem?.paymentDetailId ===
                            con?.paymentDetailId && editVisible ? (
                            <div
                              className="cursor"
                              onClick={() => handleUpdateItem(con)}
                            >
                              <img src={saveImag} alt="" className="imghw30" />
                            </div>
                          ) : (
                            <div className="flex-row">
                              <div
                                className={
                                  activeTab === "Treatment" ? "" : "cursor"
                                }
                                onClick={() => {
                                  activeTab !== "Treatment" &&
                                    handleDelete(con);
                                }}
                              >
                                <img
                                  src={deleteImage}
                                  alt=""
                                  className="imghw30"
                                />
                              </div>
                              <div
                                className={`ml15 cursor`}
                                onClick={() => {
                                  // activeTab !== "Treatment" &&
                                  handleEdit(con);
                                }}
                              >
                                <img
                                  src={editImage}
                                  alt=""
                                  className="imghw30"
                                />
                              </div>
                            </div>
                          );
                      }
                      return reqObj;
                    })
                    ?.map((bil, ind) => (
                      <TableRow tabIndex={-1} key={ind}>
                        {(activeTab === "Treatment"
                          ? trtTblHdrs
                          : phrTblHdrs
                        )?.map((th, index) => (
                          <TableCell
                            key={index + th + "tr"}
                            component="th"
                            className="table-text-black capitalize"
                          >
                            <div className="upload-row">
                              <div>{bil[th]}</div>
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                {(activeTab === "Treatment"
                  ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
                  : getPharmacyRecordBasedType(billDetails?.paymentDetails)
                )?.length > 0 &&
                  (activeTab === "Treatment"
                    ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
                    : getPharmacyRecordBasedType(billDetails?.paymentDetails)
                  )
                    ?.filter((pd) => pd?.type !== "consultation")
                    ?.map((bil) => {
                      let reqTax =
                        selectedItem?.paymentDetailId === bil?.paymentDetailId
                          ? Number(
                              (Number(itemValues?.price ?? 0) / 100) *
                                Number(itemValues?.tax ?? 0) *
                                Number(itemValues?.quantity)
                            )?.toFixed(2)
                          : bil?.tax;

                      const reqObj = {
                        serviceitemname:
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible ? (
                            <div className="flex-row-ali-cen">
                              <div style={{ width: 120 }}>
                                <CustomTextField
                                  value={itemValues?.name}
                                  handleChange={(e) =>
                                    onChangeItemValue("name", e?.target?.value)
                                  }
                                  fullWidth
                                  disabled
                                />
                              </div>
                              {activeTab !== "Treatment" ? (
                                <div style={{ width: 100 }} className="ml20">
                                  <Select
                                    list={getBatchList(itemValues?.stockId)}
                                    value={itemValues?.batchNumber}
                                    addNewSelect
                                    mandatoryField
                                    handleChange={(e) =>
                                      onChangeItemValue(
                                        "batchNumber",
                                        e?.value ?? e,
                                        {
                                          batchId: e?.batchId ?? null,
                                        }
                                      )
                                    }
                                  />
                                </div>
                              ) : null}
                            </div>
                          ) : (
                            bil?.name
                          ),
                        qty:
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible ? (
                            <div className="flex-row-ali-cen">
                              <div
                                style={{
                                  width: activeTab === "Treatment" ? 80 : 50,
                                }}
                              >
                                <CustomTextField
                                  value={itemValues?.quantity}
                                  handleChange={(e) =>
                                    onChangeItemValue(
                                      "quantity",
                                      e?.target?.value
                                    )
                                  }
                                  fullWidth
                                  type="number"
                                />
                              </div>
                            </div>
                          ) : (
                            bil?.quantity
                          ),
                        unitPrice:
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible ? (
                            <div style={{ width: 100 }}>
                              <CustomTextField
                                value={itemValues?.price}
                                handleChange={(e) =>
                                  onChangeItemValue("price", e?.target?.value)
                                }
                                fullWidth
                                type="number"
                                disabled={
                                  !itemValues?.batchId &&
                                  !itemValues?.stockId &&
                                  !itemValues?.serviceId &&
                                  !itemValues?.productId
                                    ? false
                                    : true
                                }
                              />
                            </div>
                          ) : (
                            `Rs ${
                              Number(bil?.price) > 0
                                ? Number(bil?.price).toFixed(2)
                                : Number(bil?.price)
                            }`
                          ),
                        discount:
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible ? (
                            <div className="flex-row-ali-cen">
                              <div style={{ width: 80 }}>
                                <CustomTextField
                                  value={itemValues?.discount}
                                  handleChange={(e) =>
                                    onChangeItemValue(
                                      "discount",
                                      e?.target?.value
                                    )
                                  }
                                  fullWidth
                                  type="number"
                                />
                              </div>
                              <div style={{ width: 100 }} className="ml20">
                                <CustomSelect
                                  list={discountTypes}
                                  name="discountType"
                                  value={itemValues?.discountType}
                                  handleChange={(e, value) =>
                                    onChangeItemValue("discountType", value)
                                  }
                                  search
                                />
                              </div>
                            </div>
                          ) : Number(bil?.discount) > 0 ? (
                            `Rs ${Number(bil?.discount).toFixed(2)}`
                          ) : (
                            "-"
                          ),
                        adminCharge:
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible ? (
                            <CustomTextField
                              value={
                                Number(itemValues?.adminChargeAmount) *
                                Number(itemValues?.quantity)
                              }
                              fullWidth
                              disabled
                            />
                          ) : bil?.adminCharge === "Y" ? (
                            Number(bil?.adminChargeAmount) *
                              Number(bil?.quantity) >
                            0 ? (
                              `Rs ${
                                Number(bil?.adminChargeAmount) *
                                Number(bil?.quantity)?.toFixed(2)
                              }`
                            ) : (
                              "-"
                            )
                          ) : (
                            "-"
                          ),
                        total: `Rs ${Number(bil?.reqTotal).toFixed(2)}`,
                        days: bil?.days ?? "-",
                      };
                      const reqDiscount =
                        Number(
                          itemValues?.discountType?.value === "Price"
                            ? itemValues?.discount
                            : (itemValues?.price / 100) * itemValues?.discount
                        ) ?? 0;
                      let reqTotal =
                        selectedItem?.paymentDetailId ===
                          bil?.paymentDetailId && editVisible
                          ? 0
                          : Number(bil?.total).toFixed(2);

                      if (itemValues?.adminCharge === "Y") {
                        reqTotal = Number(
                          (Number(itemValues?.price ?? 0) -
                            Number(reqDiscount) +
                            Number(itemValues?.adminChargeAmount ?? 0)) *
                            Number(itemValues?.quantity)
                        );
                      }
                      if (itemValues?.adminCharge !== "Y") {
                        const stckDet = stocks?.data?.find(
                          (stc) => stc?.stockId === itemValues?.stockId
                        );
                        const batDet = stckDet?.stockBatch?.find(
                          (btc) => btc?.batchId === itemValues?.batchId
                        );
                        if (stckDet && batDet) {
                          const taxPer =
                            Number(
                              Number(batDet?.cgst ?? 0) +
                                Number(batDet?.sgst ?? 0)
                            ) ?? 0;
                          const priceAfterDiscount =
                            Number(itemValues?.price ?? 0) -
                            Number(reqDiscount);
                          reqTax =
                            (Number(priceAfterDiscount) / 100) *
                            Number(taxPer) *
                            Number(itemValues?.quantity);
                        }

                        reqTotal = Number(
                          Number(
                            (Number(itemValues?.price ?? 0) -
                              Number(reqDiscount)) *
                              Number(itemValues?.quantity) +
                              Number(reqTax ?? 0)
                          )
                        ).toFixed(2);
                      }

                      if (apnt?.appointmentStatus !== "completed") {
                        reqObj.pay =
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible ? (
                            <div
                              className="cursor"
                              onClick={() => handleUpdateItem(bil)}
                            >
                              <img src={saveImag} alt="" className="imghw30" />
                            </div>
                          ) : (
                            <div className="flex-row">
                              <div
                                className="cursor"
                                onClick={() => {
                                  handleDelete(bil);
                                }}
                              >
                                <img
                                  src={deleteImage}
                                  alt=""
                                  className="imghw30"
                                />
                              </div>

                              <div
                                className={`ml15 cursor`}
                                onClick={() => {
                                  handleEdit(bil);
                                }}
                              >
                                <img
                                  src={editImage}
                                  alt=""
                                  className="imghw30"
                                />
                              </div>
                            </div>
                          );
                      }
                      reqObj.reqTotal =
                        selectedItem?.paymentDetailId ===
                          bil?.paymentDetailId && editVisible
                          ? Number(reqTotal)
                          : bil?.total;
                      reqObj.productId = itemValues?.productId;
                      reqObj.tax =
                        reqTax > 0 ? `Rs ${Number(reqTax).toFixed(2)}` : "-";
                      return reqObj;
                    })
                    ?.map((bil, ind) => {
                      return (
                        <TableRow tabIndex={-1} key={ind}>
                          {(activeTab === "Treatment"
                            ? trtTblHdrs
                            : phrTblHdrs
                          )?.map((th, index) => (
                            <TableCell
                              key={index + th + "tr"}
                              component="th"
                              className="table-text-black capitalize"
                            >
                              <div className="upload-row">
                                <div>
                                  {th === "qty"
                                    ? bil?.[th]
                                    : th === "total"
                                    ? `Rs ${Number(bil?.reqTotal).toFixed(2)}`
                                    : typeof bil?.[th] === "number" &&
                                      th !== "days"
                                    ? Number(bil?.[th]).toFixed(2)
                                    : bil?.[th]}
                                </div>
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>

      {searchVisible ? (
        <div className="mv20 mh20">
          <div className="pr60 pl10">
            <CustomTextField
              placeholder="Search"
              fullWidth
              handleChange={(e) => setSearchValue(e?.target?.value)}
              value={searchValue}
            />
          </div>
          {searchValue?.length > 0 ? (
            <div className="br8brblack pv10 ph10 mt10">
              <div className="flex-row mv5">
                <div className="w25Per">
                  <Typography className="txt-regular fs14 blue-color">
                    Name
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="txt-regular fs14 blue-color">
                    Type
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="txt-regular fs14 blue-color">
                    Category
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="txt-regular fs14 blue-color">
                    Price
                  </Typography>
                </div>
              </div>
              {filteredList?.length > 0 ? (
                <div className="scroll-100px">
                  {filteredList?.map((fil, i) => {
                    return (
                      <div
                        className="bill-itm cursor"
                        key={i + "fil"}
                        onClick={() => handleAddItem(fil)}
                      >
                        <div className="w25Per">
                          <Typography className="txt-regular fs14">
                            {fil?.name}
                          </Typography>
                        </div>
                        <div className="w25Per">
                          <Typography className="txt-regular fs14">
                            {fil?.type}
                          </Typography>
                        </div>
                        <div className="w25Per">
                          <Typography className="txt-regular fs14">
                            {fil?.category}
                          </Typography>
                        </div>
                        <div className="w25Per">
                          <Typography className="txt-regular fs14">
                            {fil?.servicePrice ??
                            fil?.stockBatch?.[0]?.unitSellingPrice
                              ? `Rs ${Number(
                                  fil?.servicePrice ??
                                    fil?.stockBatch?.[0]?.unitSellingPrice
                                ).toFixed(2)}`
                              : "-"}
                          </Typography>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="flex-center mt20">
                  <Typography className="txt-regular">
                    No records available
                  </Typography>
                </div>
              )}

              {filteredList?.length > 0 ? null : (
                <div className="flex-row flex-center">
                  <div className="flex-start">
                    <Typography className="fs14">{searchValue}</Typography>
                  </div>
                  <div className="flex1-end mt20">
                    <div className="w15Per">
                      <CustomButton
                        text="Add New"
                        smallBtn
                        onClick={() => handleAddItem()}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : null}
        </div>
      ) : null}

      {apnt?.appointmentStatus !== "completed" ? (
        <div className="flex-row ph20">
          <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
            <CustomButton
              text="Add"
              smallBtn
              onClick={() => setSearchVisible(true)}
            />
          </Grid>
          {/* <Grid item xs={5} sm={5} md={3} lg={3} xl={3} className="ml15">
            <CustomButton
              text="Apply Discount"
              smallBtn
              onClick={() => setDiscountModVisible(true)}
            />
          </Grid> */}
        </div>
      ) : null}

      <div className="billingcontainer mt20">
        <div className="billingBox">
          <div className="flex-row-between-align-center w60Per">
            <div className="txtstyle">Discount</div>
            <div className="txtstyle">
              {Number(
                getTaxAndSubTotalAndTotal(
                  activeTab === "Treatment"
                    ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
                    : getPharmacyRecordBasedType(billDetails?.paymentDetails)
                )?.discount
              ) > 0
                ? `Rs ${Number(
                    getTaxAndSubTotalAndTotal(
                      activeTab === "Treatment"
                        ? getTreatmentRecordBasedType(
                            billDetails?.paymentDetails
                          )
                        : getPharmacyRecordBasedType(
                            billDetails?.paymentDetails
                          )
                    )?.discount
                  ).toFixed(2)}`
                : "-"}
            </div>
          </div>
          <div className="flex-row-between-align-center w60Per">
            <div className="txtstyle">
              {activeTab === "Treatment" ? "Treatment" : "Pharmacy"} Subtotal
            </div>
            <div className="txtstyle">
              Rs{" "}
              {Number(
                Number(
                  getTaxAndSubTotalAndTotal(
                    activeTab === "Treatment"
                      ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
                      : getPharmacyRecordBasedType(billDetails?.paymentDetails)
                  )?.subTotal
                ) -
                  Number(
                    getTaxAndSubTotalAndTotal(
                      activeTab === "Treatment"
                        ? getTreatmentRecordBasedType(
                            billDetails?.paymentDetails
                          )
                        : getPharmacyRecordBasedType(
                            billDetails?.paymentDetails
                          )
                    )?.tax
                  ) +
                  Number(
                    getTaxAndSubTotalAndTotal(
                      activeTab === "Treatment"
                        ? getTreatmentRecordBasedType(
                            billDetails?.paymentDetails
                          )
                        : getPharmacyRecordBasedType(
                            billDetails?.paymentDetails
                          )
                    )?.discount
                  ) -
                  (activeTab === "Treatment"
                    ? getTaxAndSubTotalAndTotal(
                        getTreatmentRecordBasedType(billDetails?.paymentDetails)
                      )?.adminCharge
                    : 0)
              )?.toFixed(2)}
            </div>
          </div>
          {activeTab === "Treatment" ? (
            <div className="flex-row-between-align-center w60Per">
              <div className="txtstyle">Admin Charge</div>
              <div className="txtstyle">
                {getTaxAndSubTotalAndTotal(
                  getTreatmentRecordBasedType(billDetails?.paymentDetails)
                )?.adminCharge > 0
                  ? `Rs ${Number(
                      getTaxAndSubTotalAndTotal(
                        getTreatmentRecordBasedType(billDetails?.paymentDetails)
                      )?.adminCharge
                    )?.toFixed(2)}`
                  : "-"}
              </div>
            </div>
          ) : null}

          {activeTab !== "Treatment" ? (
            <>
              <div className="flex-row-between-align-center w60Per">
                <div className="txtstyle">Taxes (CGST) </div>
                <div className="txtstyle">
                  {Number(
                    getTaxAndSubTotalAndTotal(
                      getPharmacyRecordBasedType(billDetails?.paymentDetails)
                    )?.tax
                  ) /
                    2 >
                  0
                    ? `Rs ${Number(
                        Number(
                          getTaxAndSubTotalAndTotal(
                            getPharmacyRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.tax
                        ) / 2
                      )?.toFixed(2)}`
                    : "-"}
                </div>
              </div>
              <div className="flex-row-between-align-center w60Per">
                <div className="txtstyle">Taxes (SGST) </div>
                <div className="txtstyle">
                  {Number(
                    getTaxAndSubTotalAndTotal(
                      getPharmacyRecordBasedType(billDetails?.paymentDetails)
                    )?.tax
                  ) /
                    2 >
                  0
                    ? `Rs ${Number(
                        Number(
                          getTaxAndSubTotalAndTotal(
                            getPharmacyRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.tax
                        ) / 2
                      )?.toFixed(2)}`
                    : "-"}
                </div>
              </div>
            </>
          ) : null}

          <div className="flex-row mt10">
            <div className="flex-row-between-align-center w60Per balancecontainer">
              <div className="txt-semi-bold fs14 blue-color">
                {activeTab === "Treatment" ? "Treatment" : "Pharmacy"} Total
              </div>
              <div className="txt-semi-bold fs14 blue-color">
                Rs{" "}
                {Number(
                  getTaxAndSubTotalAndTotal(
                    activeTab === "Treatment"
                      ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
                      : getPharmacyRecordBasedType(billDetails?.paymentDetails)
                  )?.subTotal
                )?.toFixed(2)}
              </div>
            </div>
            <div className="flex-center ml20">
              <div
                className="flex-center cursor"
                onClick={() => {
                  setPrntPrevVsble(true);
                }}
              >
                <img src={print} alt="" className="imghw30" />
              </div>
              <div
                className="flex-center cursor ml20"
                onClick={() => {
                  setPayValues({
                    ...payValues,
                    amount: billDetails?.balanceDue ?? 0,
                  });
                  setPayModalVisible(true);
                }}
              >
                <img src={payImg} alt="" className="img-h40" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        open={prntPrevVsble}
        onClose={handleClosePrintModal}
        header=""
        modal
        modalWidth={90}
      >
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <div ref={contentToPrint} className="bg">
            <div>
              <div className="flex-row-ali-cen mv20">
                <div className="w30Per">
                  <div>
                    <div className="flex-center">
                      {profile?.image ? (
                        <img src={profile?.image} className="img-h75" alt="" />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {profile?.name?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                    <Typography className="flex-center fs18 txt-semi-bold mt10 blue-color">
                      {clinicDet?.name ?? profile?.name ?? ""}
                    </Typography>
                  </div>
                </div>
                <div className="w40Per flex-center">
                  <div className="font-bold fs18 blue-color">
                    TREATMENT INVOICE
                  </div>
                </div>
                <div className="w30Per flex1-end">
                  <div className="flex-column">
                    <div className="font-bold fs12 blue-color">
                      Business Address:
                    </div>
                    <div className="header-right-text2">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          CLINIC TAX ID:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="line"></div>
              <div className="flex1-end mt10 ph30">
                <div className="flex-column">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Payment Status
                    </Typography>
                    <Typography
                      className={`ml10 fs16 font-bold capitalize ${
                        billDetails?.status === "paid"
                          ? "green2"
                          : billDetails?.status === "unpaid"
                          ? "red2"
                          : "orange-color"
                      }`}
                    >
                      {billDetails?.status}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Total
                    </Typography>
                    <Typography className="black fs16 font-bold ml10">
                      Rs{" "}
                      {Number(
                        getTaxAndSubTotalAndTotal(
                          getTreatmentRecordBasedType(
                            billDetails?.paymentDetails
                          )
                        )?.subTotal +
                          getTaxAndSubTotalAndTotal(
                            getPharmacyRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.subTotal
                      )?.toFixed(2)}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Amount Paid
                    </Typography>
                    <Typography className="green-color fs16 font-bold ml10">
                      Rs{" "}
                      {Number(billDetails?.amtPaid) > 0
                        ? Number(billDetails?.amtPaid)?.toFixed(2)
                        : Number(billDetails?.amtPaid)}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Balance Due
                    </Typography>
                    <Typography className="yellow-color fs16 font-bold ml10">
                      Rs{" "}
                      {Number(
                        Number(
                          getTaxAndSubTotalAndTotal(
                            getTreatmentRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.subTotal +
                            getTaxAndSubTotalAndTotal(
                              getPharmacyRecordBasedType(
                                billDetails?.paymentDetails
                              )
                            )?.subTotal
                        ) -
                          (Number(billDetails?.amtPaid ?? 0) -
                            Number(billDetails?.discount ?? 0))
                      )?.toFixed(2)}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="lower-container">
                <div className="box-container">
                  <div className="row-container">
                    <div>
                      <div className="colum-header">Pet Name</div>
                      <div className="colum-data">{petDet?.petName}</div>
                    </div>
                    <div>
                      <div className="colum-header">Parent Name</div>
                      <div className="colum-data capitalize">
                        {petDet?.userName}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Number</div>
                      <div className="colum-data">
                        {billDetails?.invoiceNumbers ?? ""}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Date</div>
                      <div className="colum-data">
                        {moment(new Date(billDetails?.createdDate)).format(
                          "DD MMM YYYY"
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="thin-line"></div>

                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>HSN/SAC Code</th>
                        <th>SERVICE / ITEM NAME</th>
                        <th>QTY</th>
                        <th>PRICE</th>
                        <th>DISCOUNT (Rs)</th>
                        <th>ADMIN CHARGE</th>
                        <th>TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getTreatmentRecordBasedType(billDetails?.paymentDetails)
                        ?.length > 0 &&
                        getTreatmentRecordBasedType(billDetails?.paymentDetails)
                          ?.filter((pd) => pd?.type === "consultation")
                          ?.map((con) => (
                            <tr>
                              <td>-</td>
                              <td>
                                <div className="flex-row-ali-cen">
                                  Consultation (
                                  {con?.name === "Home"
                                    ? "Home Visit"
                                    : con?.name}
                                  ){" "}
                                  {billDetails?.doctorName?.length > 0
                                    ? " - "
                                    : ""}
                                  <div className="font-bold fs12 black ml3">
                                    {billDetails?.doctorName?.length > 0
                                      ? `${
                                          billDetails?.doctorId ===
                                          billDetails?.clinicId
                                            ? ""
                                            : "Dr. "
                                        } ${billDetails?.doctorName}`
                                      : ""}
                                  </div>
                                  {billDetails?.registrationNo?.length > 0 ? (
                                    <div className="flex-row-ali-cen">
                                      <div className="font-regular fs12 black ml5">
                                        (
                                      </div>
                                      <div className="font-bold fs12 black ml2">
                                        RegNo:
                                      </div>
                                      <div className="font-regular fs12 black ml5 capitalize">
                                        {billDetails?.registrationNo ??
                                          billDetails?.registrationNo}{" "}
                                        )
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </td>
                              <td>1</td>
                              <td>Rs {Number(con?.price)?.toFixed(2)}</td>
                              <td>-</td>
                              <td>
                                {con?.tax > 0
                                  ? Number(con?.tax)?.toFixed(2)
                                  : "-"}
                              </td>
                              <td>Rs {Number(con?.total)?.toFixed(2)}</td>
                            </tr>
                          ))}

                      {getTreatmentRecordBasedType(billDetails?.paymentDetails)
                        ?.length > 0 &&
                        getTreatmentRecordBasedType(billDetails?.paymentDetails)
                          ?.filter((pd) => pd?.type !== "consultation")
                          ?.map((itm, i) => {
                            let batchDet = null;
                            let stock = null;
                            if (itm?.batchId) {
                              stock = stocks?.data?.find(
                                (stc) => stc?.stockId === itm?.stockId
                              );
                              batchDet = stock?.stockBatch?.find(
                                (bat) => bat?.batchId === itm?.batchId
                              );
                            }

                            return (
                              <tr key={i}>
                                <td>
                                  {stock?.hsnSacCode?.length > 0
                                    ? stock?.hsnSacCode
                                    : "-"}
                                </td>
                                <td>
                                  <div className="flex-column">
                                    {itm?.name}
                                    {batchDet ? (
                                      <div className="flex-row-ali-cen mt3">
                                        <Typography className="txt-regular fs10 gray-color">
                                          Mfg. Date:{" "}
                                          {moment(batchDet?.mfgDate).format(
                                            "DD MMM YYYY"
                                          )}
                                          {", "}
                                          Exp. Date:{" "}
                                          {moment(batchDet?.expiryDate).format(
                                            "DD MMM YYYY"
                                          )}
                                          {batchDet?.batchNo?.length > 0
                                            ? `, Batch No.: ${batchDet?.batchNo}`
                                            : ""}
                                        </Typography>
                                      </div>
                                    ) : null}
                                  </div>
                                </td>
                                <td>{itm?.quantity}</td>
                                <td>Rs {Number(itm?.price)?.toFixed(2)}</td>
                                <td>
                                  {Number(itm?.discount) > 0
                                    ? Number(itm?.discount)?.toFixed(2)
                                    : "-"}
                                </td>
                                <td>
                                  {itm?.adminCharge === "Y" &&
                                  itm?.adminChargeAmount > 0
                                    ? Number(itm?.adminChargeAmount)?.toFixed(2)
                                    : "-"}
                                </td>
                                <td>Rs {Number(itm?.total)?.toFixed(2)}</td>
                              </tr>
                            );
                          })}

                      <tr>
                        <td colSpan="6">
                          <hr className="thin-line2" />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="12">
                          <div className="flex-row-between">
                            <div className="w65Per ali-itm-flx-end">
                              <div className="flex-column">
                                <div className="txt-semi-bold fs12 black">
                                  Disclaimer:
                                </div>
                                <Typography className="fs12 txt-regular gray-color mt5">
                                  {clinicDet?.disclaimer}
                                </Typography>
                              </div>
                            </div>
                            <div className="w35Per flex-end pr10">
                              <div className="flex-column w100Per">
                                <div className="flex-row-ali-cen mb5">
                                  <div className="w70Per">
                                    <div className="txtstyle">Discount</div>
                                  </div>
                                  <div className="w30Per flex-end">
                                    <div className="txtstyle">
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getTreatmentRecordBasedType(
                                            billDetails?.paymentDetails
                                          )
                                        )?.discount
                                      ) > 0
                                        ? `Rs ${Number(
                                            getTaxAndSubTotalAndTotal(
                                              getTreatmentRecordBasedType(
                                                billDetails?.paymentDetails
                                              )
                                            )?.discount
                                          ).toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">
                                      Treatment Subtotal
                                    </div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      Rs{" "}
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getTreatmentRecordBasedType(
                                            billDetails?.paymentDetails
                                          )
                                        )?.subTotal +
                                          getTaxAndSubTotalAndTotal(
                                            getTreatmentRecordBasedType(
                                              billDetails?.paymentDetails
                                            )
                                          )?.discount -
                                          (getTaxAndSubTotalAndTotal(
                                            getTreatmentRecordBasedType(
                                              billDetails?.paymentDetails
                                            )
                                          )?.adminCharge ?? 0)
                                      )?.toFixed(2)}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Admin Charge</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      {getTaxAndSubTotalAndTotal(
                                        getTreatmentRecordBasedType(
                                          billDetails?.paymentDetails
                                        )
                                      )?.adminCharge > 0
                                        ? `Rs ${Number(
                                            getTaxAndSubTotalAndTotal(
                                              getTreatmentRecordBasedType(
                                                billDetails?.paymentDetails
                                              )
                                            )?.adminCharge
                                          )?.toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="balancecontainer ph5 mt10">
                                  <div className="flex-row-ali-cen w100Per">
                                    <div className="w60Per">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        Total
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        Rs{" "}
                                        {Number(
                                          getTaxAndSubTotalAndTotal(
                                            getTreatmentRecordBasedType(
                                              billDetails?.paymentDetails
                                            )
                                          )?.subTotal
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <div className="mb20" />
                    </tbody>
                  </table>
                  <div className="flex-row mv20 ph10">
                    <img
                      src={require("../../../../assets/images/jpg/WoofQrCode.jpeg")}
                      alt=""
                      className="img-h50"
                    />
                    <div className="blu-back wh50 flex-center">
                      <img
                        src={require("../../../../assets/images/png/VetInstantLogo.png")}
                        alt=""
                        className="img-h40"
                      />
                    </div>
                    <div className="flex-center">
                      <div className="font-bold fs14 ml20">
                        Scan to download our app
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-break" />
            <div>
              <div className="flex-row-ali-cen mv20">
                <div className="w30Per">
                  <div>
                    <div className="flex-center">
                      {profile?.image ? (
                        <img src={profile?.image} className="img-h75" alt="" />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {profile?.name?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                    <Typography className="flex-center fs18 txt-semi-bold mt10 blue-color">
                      {clinicDet?.name ?? profile?.name ?? ""}
                    </Typography>
                  </div>
                </div>
                <div className="w40Per flex-center">
                  <div className="font-bold fs18 blue-color">
                    PHARMACY INVOICE
                  </div>
                </div>
                <div className="w30Per flex1-end">
                  <div className="flex-column">
                    <div className="font-bold fs12 blue-color">
                      Business Address:
                    </div>
                    <div className="header-right-text2">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.pharmacyTaxId?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          PHARMACY TAX ID:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.pharmacyTaxId ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="line"></div>
              <div className="flex1-end mt10 ph30">
                <div className="flex-column">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Payment Status
                    </Typography>
                    <Typography
                      className={`ml10 fs16 font-bold capitalize ${
                        billDetails?.status === "paid"
                          ? "green2"
                          : billDetails?.status === "unpaid"
                          ? "red2"
                          : "orange-color"
                      }`}
                    >
                      {billDetails?.status}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Total
                    </Typography>
                    <Typography className="black fs16 font-bold ml10">
                      Rs{" "}
                      {Number(
                        getTaxAndSubTotalAndTotal(
                          getTreatmentRecordBasedType(
                            billDetails?.paymentDetails
                          )
                        )?.subTotal +
                          getTaxAndSubTotalAndTotal(
                            getPharmacyRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.subTotal
                      )?.toFixed(2)}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Amount Paid
                    </Typography>
                    <Typography className="green-color fs16 font-bold ml10">
                      Rs{" "}
                      {Number(billDetails?.amtPaid) > 0
                        ? Number(billDetails?.amtPaid)?.toFixed(2)
                        : Number(billDetails?.amtPaid)}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Balance Due
                    </Typography>
                    <Typography className="yellow-color fs16 font-bold ml10">
                      Rs{" "}
                      {Number(
                        Number(
                          getTaxAndSubTotalAndTotal(
                            getTreatmentRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.subTotal +
                            getTaxAndSubTotalAndTotal(
                              getPharmacyRecordBasedType(
                                billDetails?.paymentDetails
                              )
                            )?.subTotal
                        ) -
                          (Number(billDetails?.amtPaid ?? 0) -
                            Number(billDetails?.discount ?? 0))
                      )?.toFixed(2)}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="lower-container">
                <div className="box-container">
                  <div className="row-container">
                    <div>
                      <div className="colum-header">Pet Name</div>
                      <div className="colum-data">{petDet?.petName}</div>
                    </div>
                    <div>
                      <div className="colum-header">Parent Name</div>
                      <div className="colum-data capitalize">
                        {petDet?.userName}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Number</div>
                      <div className="colum-data">
                        {billDetails?.invoiceNumbers ?? ""}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Date</div>
                      <div className="colum-data">
                        {moment(new Date(billDetails?.createdDate)).format(
                          "DD MMM YYYY"
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="thin-line"></div>

                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>HSN/SAC Code</th>
                        <th>SERVICE / ITEM NAME</th>
                        <th>QTY</th>
                        <th>PRICE</th>
                        <th>DISCOUNT (Rs)</th>
                        <th>TAX</th>
                        <th>TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getPharmacyRecordBasedType(billDetails?.paymentDetails)
                        ?.length > 0 &&
                        getPharmacyRecordBasedType(billDetails?.paymentDetails)
                          ?.filter((pd) => pd?.type !== "consultation")
                          ?.map((itm, i) => {
                            let batchDet = null;
                            let stock = null;
                            if (itm?.batchId) {
                              stock = stocks?.data?.find(
                                (stc) => stc?.stockId === itm?.stockId
                              );
                              batchDet = stock?.stockBatch?.find(
                                (bat) => bat?.batchId === itm?.batchId
                              );
                            }

                            return (
                              <tr key={i}>
                                <td>
                                  {stock?.hsnSacCode?.length > 0
                                    ? stock?.hsnSacCode
                                    : "-"}
                                </td>
                                <td>
                                  <div className="flex-column">
                                    {itm?.name}
                                    {batchDet ? (
                                      <div className="flex-row-ali-cen mt3">
                                        <Typography className="txt-regular fs10 gray-color">
                                          Mfg. Date:{" "}
                                          {moment(batchDet?.mfgDate).format(
                                            "DD MMM YYYY"
                                          )}
                                          {", "}
                                          Exp. Date:{" "}
                                          {moment(batchDet?.expiryDate).format(
                                            "DD MMM YYYY"
                                          )}
                                          {batchDet?.batchNo?.length > 0
                                            ? `, Batch No.: ${batchDet?.batchNo}`
                                            : ""}
                                        </Typography>
                                      </div>
                                    ) : null}
                                  </div>
                                </td>
                                <td>{itm?.quantity}</td>
                                <td>Rs {Number(itm?.price)?.toFixed(2)}</td>
                                <td>
                                  {Number(itm?.discount) > 0
                                    ? Number(itm?.discount)?.toFixed(2)
                                    : "-"}
                                </td>
                                <td>
                                  {itm?.tax > 0
                                    ? Number(itm?.tax)?.toFixed(2)
                                    : "-"}
                                </td>
                                <td>Rs {Number(itm?.total)?.toFixed(2)}</td>
                              </tr>
                            );
                          })}
                      <tr>
                        <td colSpan="6">
                          <hr className="thin-line2" />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="12">
                          <div className="flex-row-between">
                            <div className="w65Per ali-itm-flx-end">
                              <div className="flex-column">
                                <div className="txt-semi-bold fs12 black">
                                  Disclaimer:
                                </div>
                                <Typography className="fs12 txt-regular gray-color mt5">
                                  {clinicDet?.disclaimer}
                                </Typography>
                              </div>
                            </div>
                            <div className="w35Per flex-end pr10">
                              <div className="flex-column w100Per">
                                <div className="flex-row-ali-cen mb5">
                                  <div className="w70Per">
                                    <div className="txtstyle">Discount</div>
                                  </div>
                                  <div className="w30Per flex-end">
                                    <div className="txtstyle">
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            billDetails?.paymentDetails
                                          )
                                        )?.discount
                                      ) > 0
                                        ? `Rs ${Number(
                                            getTaxAndSubTotalAndTotal(
                                              getPharmacyRecordBasedType(
                                                billDetails?.paymentDetails
                                              )
                                            )?.discount
                                          ).toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">
                                      Pharmacy Subtotal
                                    </div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      Rs{" "}
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            billDetails?.paymentDetails
                                          )
                                        )?.subTotal -
                                          getTaxAndSubTotalAndTotal(
                                            getPharmacyRecordBasedType(
                                              billDetails?.paymentDetails
                                            )
                                          )?.tax +
                                          getTaxAndSubTotalAndTotal(
                                            getPharmacyRecordBasedType(
                                              billDetails?.paymentDetails
                                            )
                                          )?.discount
                                      )?.toFixed(2)}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Taxes (CGST)</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            billDetails?.paymentDetails
                                          )
                                        )?.tax
                                      ) /
                                        2 >
                                      0
                                        ? `Rs ${Number(
                                            Number(
                                              getTaxAndSubTotalAndTotal(
                                                getPharmacyRecordBasedType(
                                                  billDetails?.paymentDetails
                                                )
                                              )?.tax
                                            ) / 2
                                          )?.toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Taxes (SGST)</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            billDetails?.paymentDetails
                                          )
                                        )?.tax
                                      ) /
                                        2 >
                                      0
                                        ? `Rs ${Number(
                                            Number(
                                              getTaxAndSubTotalAndTotal(
                                                getPharmacyRecordBasedType(
                                                  billDetails?.paymentDetails
                                                )
                                              )?.tax
                                            ) / 2
                                          )?.toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="balancecontainer ph5 mt10">
                                  <div className="flex-row-ali-cen w100Per">
                                    <div className="w60Per">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        Total
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        Rs{" "}
                                        {Number(
                                          getTaxAndSubTotalAndTotal(
                                            getPharmacyRecordBasedType(
                                              billDetails?.paymentDetails
                                            )
                                          )?.subTotal
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <div className="mb20" />
                    </tbody>
                  </table>
                  <div className="flex-row mv20 ph10">
                    <img
                      src={require("../../../../assets/images/jpg/WoofQrCode.jpeg")}
                      alt=""
                      className="img-h50"
                    />
                    <div className="blu-back wh50 flex-center">
                      <img
                        src={require("../../../../assets/images/png/VetInstantLogo.png")}
                        alt=""
                        className="img-h40"
                      />
                    </div>
                    <div className="flex-center">
                      <div className="font-bold fs14 ml20">
                        Scan to download our app
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="back-white"
          >
            <div className="flex-end">
              <div className="mr20 mv20">
                <CustomButton
                  text="Download"
                  onClick={() =>
                    handlePrint(null, () => contentToPrint.current)
                  }
                  smallBtn
                />
              </div>
            </div>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={discountModVisible}
        onClose={onDiscountModClose}
        header="Apply Discount"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={0.5} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 selectypetext ">
              Discount Type
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Checkbox
              radio
              onChange={(e) => onChangeDiscount("type", e?.target?.value)}
              radios={radioDiscountTypes}
              defaultValue="percentage"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextField
              label={`Discount  ${
                discountValues?.type === "price" ? "Price" : "Percentage"
              }`}
              name="amt"
              fullWidth
              handleChange={(e) => onChangeDiscount("amt", e?.target?.value)}
              value={discountValues?.amt}
              labelTop
            />
          </Grid>

          <div className="flex1-end mt20">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <CustomButton text="Add" onClick={handleAddDiscount} />
            </Grid>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure want to delete the list?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleDelConfirm}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={payModalVisible}
        onClose={payModClose}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <Card
          sx={{
            borderRadius: 1,
            padding: 2,
            borderTopColor: `${getBorderColor(billDetails?.status)}`,
          }}
          className="CustomCard-back-bill-payment"
        >
          <div className="maint">
            <div className="flex-row topt">
              <Grid item xs={3} sm={3} md={4} lg={4} xl={4}>
                <div className="flex-center">
                  {petDet?.image ? (
                    <CardMedia
                      image={petDet?.image}
                      className="CustomCard-img3-bill"
                    />
                  ) : (
                    <div className="flex-center h50img">
                      <Typography className="font-bold fs30 white-color capitalize">
                        {petDet?.petName?.[0]}
                      </Typography>
                    </div>
                  )}
                </div>
              </Grid>
              <div className="flex-row">
                <div className="flex-start">
                  <div className="flex-column">
                    <div className="flex-row">
                      <Typography
                        variant="body1"
                        className="mb10 font-bold fs14 capitalize"
                      >
                        {petDet?.petName}
                      </Typography>
                      <Typography
                        variant="body1"
                        className={`ml5 capitalize font-medium fs14 ${
                          petDet?.gender === "male"
                            ? "card-blue-color"
                            : "card-rose-color"
                        }`}
                      >
                        {`(${petDet?.gender})`}
                      </Typography>
                    </div>
                    <Typography
                      variant="body2"
                      className="mb10 txt-regular card-gray-color fs12"
                    >
                      {petDet?.breed}
                    </Typography>
                  </div>
                </div>
              </div>
              <div />
            </div>
            <div>
              <div className="flex-row parentcontainer">
                <div className="flex-row  iconcontainer">
                  <AccountCircleOutlinedIcon sx={{ width: 25, height: 25 }} />
                  <Typography className="  font-bold fs14 capitalize flex-center h35">
                    {petDet?.userName}
                  </Typography>
                </div>
                <div className="meeting-doctor capitalize">
                  Meeting {apnt?.doctorId === apnt?.hospitalId ? "" : "Dr. "}
                  {apnt?.doctorName}
                </div>
              </div>
              <div className="trdatenew">{apnt?.appointmentDate}</div>
              <div
                className={
                  billDetails?.balanceDue === 0 ||
                  billDetails?.balanceDue === "Nil"
                    ? "balancedueblue"
                    : "balanceduered"
                }
              >
                Balance due:{" "}
                {Number(
                  Number(
                    getTaxAndSubTotalAndTotal(
                      getTreatmentRecordBasedType(billDetails?.paymentDetails)
                    )?.subTotal +
                      getTaxAndSubTotalAndTotal(
                        getPharmacyRecordBasedType(billDetails?.paymentDetails)
                      )?.subTotal
                  ) -
                    (Number(billDetails?.amtPaid ?? 0) -
                      Number(billDetails?.discount ?? 0))
                ) > 0
                  ? Number(
                      Number(
                        getTaxAndSubTotalAndTotal(
                          getTreatmentRecordBasedType(
                            billDetails?.paymentDetails
                          )
                        )?.subTotal +
                          getTaxAndSubTotalAndTotal(
                            getPharmacyRecordBasedType(
                              billDetails?.paymentDetails
                            )
                          )?.subTotal
                      ) -
                        (Number(billDetails?.amtPaid ?? 0) -
                          Number(billDetails?.discount ?? 0))
                    )?.toFixed(2)
                  : "-"}
              </div>
              <div className="datecontainer"></div>
            </div>
          </div>
          <div
            className={`conttype ${
              apnt?.appointmentType === "Physical"
                ? "card-con-blue-back"
                : "virtual-bg-color"
            }`}
          >
            {apnt?.appointmentType}
          </div>
        </Card>
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label="Amount"
              name="amount"
              fullWidth
              handleChange={(e) =>
                handleChangeValues("amount", e?.target?.value)
              }
              value={payValues?.amount}
              labelTop
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="font-medium fs14 black2">Payment Mode</div>
            <Select
              list={PaymentTypeList}
              value={payValues?.paymentMode}
              handleChange={(e, value) =>
                handleChangeValues("paymentMode", value)
              }
              name="paymentMode"
              search
            />
          </Grid>

          <div className="flex1-end mt20">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <CustomButton text="Pay" onClick={finalPayment} />
            </Grid>
          </div>
        </Grid>
      </CustomModal>
    </div>
  );
};

export default Billing;
